export default __webpack_public_path__ + "static/media/Green-Beauty-Hoop-Drop-Earrings.43d55dfe.jpg";